<template>
  <div class="noticeList">   <!--新闻列表-->
    <breadcrumb class="breadcrumb"/>
    <el-row class="main-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-form :inline="true" class="demo-form-inline" size="small" >
            <el-form-item label="标题：">
              <el-input v-model="title" placeholder="输入标题" @keyup.enter.native="onSubmit" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 15px">
              <el-button type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
            </el-form-item>
            <div class="treeOption">
              <el-button type="success" size="small" icon="el-icon-plus" @click="addNotice">新增</el-button>
              <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteNotice">删除</el-button>
            </div>
          </el-form>
        </div>
        <div class="tableCenter">
          <el-table
            :data="noticeList"
            style="width: 100%" border
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              type="index">
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              >
            </el-table-column>
            <el-table-column
              prop="time"
              label="时间"
            >
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="modifyNotice(scope.row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 15px;float: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </el-card>
    </el-row>
    <!--新增dialog-->
    <el-dialog
      :title="noticeTitleName"
      :visible.sync="dialogAddChange"
      width="800px"
      :close-on-click-modal="false"
      class="top">
      <div>
        <el-form ref="form" :model="formResult" label-width="100px">
          <el-form-item label="标题：">
            <el-input v-model="formResult.title"></el-input>
          </el-form-item>
          <el-form-item label="PDF文件："> 
            <el-upload
              ref="upload"
              action="/api/notice/uploadPdf"
              :limit="1"
              :on-success="handleSuccess"
              :file-list="fileList"
              accept=".pdf,.PDF">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddChange = false">取 消</el-button>
        <el-button type="primary" @click="submitNotice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    data() {
      return {
        noticeTitleName:'',
        dialogAddChange:false,
        title:'',
        noticeList:[],
        isadd:true,
        formResult:{ID:'',title:'',filePath:'',fileName:'',},
        multipleSelection: [],
        fileList:[],
        pageSize:20,
        pageNo:1,
        totalCount:0,
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init(){
        let vm =this;
        let params = {
          title:vm.title,
          pageNo:vm.pageNo,
          pageSize:vm.pageSize,
        }
        vm.axios.get('/notice/queryNoticeList', {params: params})
          .then(res => {
            vm.noticeList = [];
            res.data.noticeList.list.forEach((val)=>{
              val.time = val.createDate?moment(val.createDate).utc(0).format('YYYY-MM-DD'):'';
              vm.noticeList.push(val);
            })
            vm.totalCount = res.data.noticeList.count[0].count;
          }).catch(error => {
        })
      },
      //查询
      onSubmit(){
        this.init();
      },
      //pageSize改变事件
      handleSizeChange(val){
        let vm =this;
        vm.pageSize = val;
        vm.pageNo = 1;
        this.init();
      },
      //pageNo改变事件
      handleCurrentChange(val){
        let vm =this;
        vm.pageNo = val;
        this.init();
      },
      //新增
      addNotice(){
        let vm =this;
        vm.isadd = true;
        vm.formResult.title ='';
        vm.formResult.filePath = '';
        vm.formResult.fileName = '';
        vm.menuTitleName = '新增';
        vm.dialogAddChange = true;
        setTimeout(()=>{
          this.$refs.upload.clearFiles();
        })
      },
      //修改
      modifyNotice(row){
        let vm = this;
        vm.isadd = false;
        vm.menuTitleName = '修改';
        vm.formResult.ID = row.ID;
        vm.formResult.title = row.title;
        vm.formResult.filePath = row.filePath;
        vm.formResult.fileName = row.fileName;
        vm.dialogAddChange = true;
        setTimeout(()=>{
          this.$refs.upload.clearFiles();
          vm.fileList = [{name: row.fileName, url: row.filePath}];
        })
      },
      submitNotice(){
        let vm =this;
        let params = {};
        params.title = vm.formResult.title;
        params.filepath = vm.formResult.filePath;
        params.filename = vm.formResult.fileName;
        
        if(vm.isadd){
          vm.axios.post('/notice/saveNotice', {params: params})
          .then(res => {
            if(res.data.resultCode === '00'){
              vm.init();
              vm.dialogAddChange = false;
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success'
              });
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '添加失败',
              type: 'error'
            });
          })
        }else{
          params.ID = vm.formResult.ID;
          vm.axios.post('/notice/modifyNotice', {params: params})
          .then(res => {
            if(res.data.resultCode === '00'){
              vm.init();
              vm.dialogAddChange = false;
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              });
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '修改失败',
              type: 'error'
            });
          })
        }
      },
      deleteNotice(){
        let vm =this;
        if(vm.multipleSelection.length > 0){
          this.$confirm('确定要删除所选内容吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            vm.axios.post('/notice/deleteNotice', {params: vm.multipleSelection})
            .then(res => {
              if(res.data.resultCode === '00'){
                vm.init();
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success'
                });
              }
            }).catch(error => {
              this.$message({
                showClose: true,
                message: '删除失败',
                type: 'error'
              });
            })
          }).catch(() => {
          });
        }else{
          this.$message({
            showClose: true,
            message: '请选择需要删除的内容',
            type: 'warning'
          });
        }
      },
      
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      
      handleSuccess(file, fileList) {
        this.formResult.filePath = file.url;
        this.formResult.fileName = file.filename;
      },
    },
  }
</script>

<style scoped lang="scss">
  .noticeList{
    .main-container{
      .tableCenter{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/management/noticeList.vue